import React from 'react'
import { Navigate, useParams } from 'react-router'
import { useDisableAppHeaderSticky } from '@core/Areas/AppHeader/hooks/useDisableAppHeaderSticky'
import { MainContainer } from '@core/Components/Containers'
import { AccountActivityMain } from './Components/Main'
import { RacingSportsTabs } from './Components/RacingSportsTabs'
import { ACCOUNT_ACTIVITY_ROUTE } from './constants'
import type { Tabs } from './types'

const tabs: Tabs[] = ['pending', 'results', 'rebet', 'transactions']

/** @deprecated To be replaced by unified My Bets */
export const ActivityPage: React.FC = () => {
  const { tab } = useParams<{ tab: Tabs }>()

  useDisableAppHeaderSticky()

  if (!tab || !tabs.includes(tab)) {
    return <Navigate to={`/${ACCOUNT_ACTIVITY_ROUTE}/${tabs[0]}`} replace />
  }

  return (
    <MainContainer background='surface300'>
      <RacingSportsTabs isRacing activeTab={tab} />

      <AccountActivityMain activeTab={tab} />
    </MainContainer>
  )
}
